// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getCategoryRequest: ['data'],
  getCategorySuccess: ['data'],
  getCategoryFailure: ['err'],

  getSingleCategoryRequest: ['data'],
  getSingleCategorySuccess: ['data'],
  getSingleCategoryFailure: ['err'],

  createCategoryRequest: ['data'],
  createCategorySuccess: ['data'],
  createCategoryFailure: ['err'],

  updateCategoryRequest: ['data'],
  updateCategorySuccess: ['data'],
  updateCategoryFailure: ['err']

})

export const CategoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  category_single: {},
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const successSingle = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    category_single: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const failureSingle = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_single: {} })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CATEGORY_SUCCESS]: success,
  [Types.GET_CATEGORY_REQUEST]: request,
  [Types.GET_CATEGORY_FAILURE]: failure,

  [Types.GET_SINGLE_CATEGORY_SUCCESS]: success,
  [Types.GET_SINGLE_CATEGORY_REQUEST]: request,
  [Types.GET_SINGLE_CATEGORY_FAILURE]: failure,

  [Types.CREATE_CATEGORY_SUCCESS]: success,
  [Types.CREATE_CATEGORY_REQUEST]: request,
  [Types.CREATE_CATEGORY_FAILURE]: failure,

  [Types.UPDATE_CATEGORY_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_CATEGORY_REQUEST]: manipulateRequest,
  [Types.UPDATE_CATEGORY_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/CategoryRedux.js